import {
  ICON_ONLY_BUTTON_ICON_STYLES,
  ICON_ONLY_BUTTON_STYLES,
} from "../../../../../styles";

export const addComponetsButtonStyles = (
  hasText?: boolean,
  bigButton?: boolean,
) => ({
  buttonStyles: `${ICON_ONLY_BUTTON_STYLES} ${
    hasText
      ? "flex w-max min-w-max text-sm font-medium text-stone-900 dark:text-white"
      : ICON_ONLY_BUTTON_ICON_STYLES
  } mt-auto disabled:cursor-not-allowed`,
  iconStyles: bigButton ? "w-5" : "w-4",
  textStyles: hasText ? "ml-2" : "sr-only",
});
